module.exports = __webpack_public_path__ + "static/media/mobile8.f6a0db2a.png";